import * as Constants from '../constants';

export default function(state = {}, action) {
  switch (action.type) {
    case Constants.REQUEST_EEF_V2_PROVISIONED_STATUS:
      return {
        ...state,
        error: null
      };
    case Constants.RECEIVE_EEF_V2_PROVISIONED_STATUS:
      if (action.error) {
        console.log(`Error retrieving feature flag: ${action.error}`);
        return {
          ...state,
          eefV2IsProvisioned: false,
          error: action.error
        };
      }
      return {
        ...state,
        eefV2IsProvisioned: action.response
      };
    default:
      return state;
  }
}
